import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex align-items-center" }

import { ref } from 'vue';
import InputSwitch from 'primevue/inputswitch';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArchiveSwitch',
  setup(__props, { emit: __emit }) {

const emit = __emit;
const showArchived = ref(false);
const handleToggle = () => (showArchived.value ? emit(EMIT.ENABLE) : emit(EMIT.DISABLE));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputSwitch), {
      modelValue: showArchived.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showArchived).value = $event)),
      onChange: handleToggle
    }, null, 8, ["modelValue"]),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "archive_label label pl-2 align-items-center flex font-semibold" }, "Show Archived", -1))
  ]))
}
}

})